import { API_ROOT } from '../../config/config'
import { doGet, doPost, doDownload, doPut } from './utils'

// const API_ROOT = 'http://localhost:9002/api'

export const getProjectSubmitForm = (id) => {
  const url = `${API_ROOT}/proposal/${id}/project/submit`
  return doGet(url)
}

export const proposalProjectSubmitVerify = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/submit/verify`
  return doPost(url, request)
}

export const proposalProjectSubmitConfirm = (id, request) => {
  const url = `${API_ROOT}/proposal/${id}/project/submit/confirm`
  return doPost(url, request)
}

export const getproposalProjectSubmitPdf = (id) => {
  const url = `${API_ROOT}/files/${id}/proposal/form`
  return doDownload(url)
}

export const doUpdatePersonId = (id, personId) => {
  const url = `${API_ROOT}/proposal/${id}/project/${personId}`
  return doPut(url)
}
